import { split } from 'lodash';

export const extractMime = (encodedString: string) => {
  const splittedString = split(encodedString, ',');
  const splittedMime = split(splittedString[0], ';');
  const extractedMime = split(splittedMime[0], ':');

  return extractedMime[1];
};

export const extractBase64 = (encodedString: string) => {
  return split(encodedString, ',')[1];
};
